import 'flickity-fade';
import Flickity from 'flickity';

class MagicHero extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.init();
    }

    init() {
        this.keywordContainer = this.querySelector('.keyword-container');
        this.videoElement = document.getElementById('hero-video');

        window.addEventListener('lazy:resize', this.handleResize.bind(this));

        this.reviewSliderEl = this.querySelector('.hero__reviews');
        this.initReviewsSlider();
    }

    handleResize() {
        if (!this.reviewSlider) {
            this.initReviewsSlider();
        }
    }

    initReviewsSlider() {
        if (!this.reviewSliderEl) return;
        if (window.innerWidth > 850) return;

        this.reviewSlider = new Flickity(this.reviewSliderEl, {
            wrapAround: true,
            prevNextButtons: false,
            autoPlay: 3000,
            selectedAttraction: 0.01,
            friction: 0.2
        });
    }
}

customElements.define('magic-hero', MagicHero);
